export default "__VITE_ASSET__BTuqjep0__"